@if(mode==="edit" || mode==="add"){
<div class="ppl-mt20">
    <form nz-form nz-row [formGroup]="paceDetailsForm" class="ppl-p0">
        @if(isAttrAvailable('mcoName')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mcoName">{{ getAttributes("mcoName").label }}
                    @if(getAttributes('mcoName').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }</nz-form-label>
                <nz-form-control class="ppl-form-control" nzLabelAlign="left" nzTooltipPlacement="topRight">
                    <nz-select formControlName="mcoName" nzMode='default' class="ppl-select" id="mcoName"
                        nzPlaceHolder="Select Organization" nzShowSearch nzAllowClear
                        [ngClass]="{'error': validationErrors['mcoName'] }">
                        @for(opt of orgList; track $index){
                        <nz-option [nzLabel]="opt.orgName" [nzValue]="opt.orgName"></nz-option>
                        }
                    </nz-select>
                    @if (validationErrors['mcoName']) {
                    <span class="pl-1 error-message" id="mcoName-error"
                        role="alert">{{validationErrors['mcoName']}}</span>
                    }
                </nz-form-control>
            </nz-row> </nz-form-item>}
        @if(isAttrAvailable('startDate')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="startDate">{{ getAttributes("startDate").label }}
                    @if(getAttributes('startDate').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control class="ppl-form-control">
                    <div>
                        <nz-date-picker formControlName="startDate" id="startDate" [nzFormat]="'MM/dd/yyyy'"
                            [nzPlaceHolder]="getAttributes('startDate').placeholder"
                            [nzDisabledDate]="disabledStartDate"
                            [ngClass]="{'error': validationErrors['startDate'] }"></nz-date-picker>
                    </div>
                    @if (validationErrors['startDate']) {
                    <span class="pl-1 error-message">{{validationErrors['startDate']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        } @if(isAttrAvailable('endDate')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="endDate">{{ getAttributes("endDate").label }}
                    @if(getAttributes('endDate').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }</nz-form-label>
                <nz-form-control class="ppl-form-control" nzLabelAlign="left" nzTooltipPlacement="topRight">
                    <div [ngClass]="{'error': validationErrors['endDate'] }">
                        <nz-date-picker formControlName="endDate" id="endDate" [nzFormat]="'MM/dd/yyyy'"
                            [nzPlaceHolder]="getAttributes('endDate').placeholder" [nzDisabledDate]="disabledEndDate"
                            [ngClass]="{'error': validationErrors['endDate'] }"></nz-date-picker>
                    </div>
                    @if (validationErrors['endDate']) {
                    <span class="pl-1 error-message" id="org-error" role="alert">{{validationErrors['endDate']}}</span>
                    }
                </nz-form-control>
            </nz-row> </nz-form-item>
        }
        @if(isAttrAvailable('cbcResult')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="cbcResult">{{ getAttributes("cbcResult").label }}
                    @if(getAttributes('cbcResult').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }</nz-form-label>
                <nz-form-control class="ppl-form-control" nzLabelAlign="left" nzTooltipPlacement="topRight">
                    <nz-select formControlName="cbcResult" nzMode='default' class="ppl-select" id="cbcResult"
                        nzPlaceHolder="Select CBC Result" nzShowSearch nzAllowClear
                        [ngClass]="{'error': validationErrors['cbcResult'] }">
                        @for(opt of statusList; track $index){
                        <nz-option [nzLabel]="opt.label" [nzValue]="opt.value"></nz-option>
                        }
                    </nz-select>
                    @if (validationErrors['cbcResult']) {
                    <span class="pl-1 error-message" id="cbcResult-error"
                        role="alert">{{validationErrors['cbcResult']}}</span>
                    }
                </nz-form-control>
            </nz-row> </nz-form-item>}
    </form>
</div>
@if(showEditError) {
    <div class="text-danger">You must change at least one value before clicking Save.</div>
}
<div class="custom-row">
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="cancelEdit()"></ppl-button>
    <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="save()"></ppl-button>
</div>
}
@else if(mode==="read"){
@if(leadStatus !== approvedStatus && !(entry === 'referral' && leadStatus === 'Review Complete') && !readOnly) {
<div class="custom-row">
    <ppl-button label="Add" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'"
    *authorize="[pageId, tabId, 'paceResults', 'section', 'edit']" (click)="add()"></ppl-button>
</div>
}

@if(paceData.length > 0){
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable" [data]="paceData"
    [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
    [loadPage]="true">
</ppl-list-table>
}@else {
<nz-row>
    <p>No Data found</p>
</nz-row>
}
}@else if (mode==="read" && !data) {
<nz-row>
    <p>No Data found</p>
</nz-row>
}